import React from 'react';
import { TrendingUp, Building2, Users } from 'lucide-react';
interface Result {
  metric: string;
  label: string;
  detail: string;
}
interface Testimonial {
  quote: string;
  author: string;
  title: string;
}
interface CaseStudySlideProps {
  content: {
    company: string;
    industry: string;
    size: string;
    challenge: string;
    solution: string;
    results: Result[];
    testimonial: Testimonial;
  };
}
export function CaseStudySlide({
  content
}: CaseStudySlideProps) {
  return <div className="bg-[#F5F5F5] rounded-2xl p-12" data-id="element-64">
      <div className="mb-8" data-id="element-65">
        <h2 className="text-4xl font-bold text-[#1C1C1C] mb-4" data-id="element-66">
          {content.company}
        </h2>
        <div className="flex items-center gap-6 text-[#4D4D4D]" data-id="element-67">
          <div className="flex items-center gap-2" data-id="element-68">
            <Building2 size={18} data-id="element-69" />
            <span data-id="element-70">{content.industry}</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-71">
            <Users size={18} data-id="element-72" />
            <span data-id="element-73">{content.size}</span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-8 mb-8" data-id="element-74">
        <div data-id="element-75">
          <h3 className="text-xl font-bold text-[#1C1C1C] mb-3" data-id="element-76">
            The Challenge
          </h3>
          <p className="text-[#4D4D4D] leading-relaxed" data-id="element-77">{content.challenge}</p>
        </div>
        <div data-id="element-78">
          <h3 className="text-xl font-bold text-[#1C1C1C] mb-3" data-id="element-79">
            The Solution
          </h3>
          <p className="text-[#4D4D4D] leading-relaxed" data-id="element-80">{content.solution}</p>
        </div>
      </div>

      <div className="bg-white rounded-xl p-8 mb-8" data-id="element-81">
        <div className="flex items-center gap-2 mb-6" data-id="element-82">
          <TrendingUp className="text-[#0FB07D]" size={24} data-id="element-83" />
          <h3 className="text-2xl font-bold text-[#1C1C1C]" data-id="element-84">Results</h3>
        </div>
        <div className="grid grid-cols-4 gap-6" data-id="element-85">
          {content.results.map((result, index) => <div key={index} className="text-center" data-id="element-86">
              <div className="text-4xl font-bold text-[#0FB07D] mb-2" data-id="element-87">
                {result.metric}
              </div>
              <div className="text-sm font-semibold text-[#1C1C1C] mb-1" data-id="element-88">
                {result.label}
              </div>
              <div className="text-xs text-[#4D4D4D]" data-id="element-89">{result.detail}</div>
            </div>)}
        </div>
      </div>

      <div className="bg-[#017C6D] rounded-xl p-8 text-white" data-id="element-90">
        <p className="text-lg italic mb-4" data-id="element-91">"{content.testimonial.quote}"</p>
        <div className="flex items-center gap-3" data-id="element-92">
          <div className="w-12 h-12 bg-[#0FB07D] rounded-full flex items-center justify-center text-xl font-bold" data-id="element-93">
            {content.testimonial.author.charAt(0)}
          </div>
          <div data-id="element-94">
            <div className="font-semibold" data-id="element-95">{content.testimonial.author}</div>
            <div className="text-sm text-white/80" data-id="element-96">
              {content.testimonial.title}
            </div>
          </div>
        </div>
      </div>
    </div>;
}
export default CaseStudySlide;